import * as urls from '../constants/NamaURLS'
import * as StringConstants from '../constants/StringConstants'
import {ajaxJSON, areEqual, isEmptyOrNull, isNotEmptyOrNull} from "./NamaCommon";

import * as PreferencesRequest from "../constants/PreferencesRequest";
import {isMobileDevice} from "./GUIUtilities";

/**
 *
 * @param {string} fieldId
 * @param {namaTypes.NaMaMetaData} metaData
 * @return {ExtendedFieldMetaData}
 */
export function findFieldMetadata(fieldId, metaData) {
    makeFieldSearchFast(metaData)
    return metaData.fieldsMetaData[metaData.fieldsIndexMap.get(fieldId)];
}

/**
 *
 * @param {string} fieldId
 * @param {ExtendedFieldMetaData} metaData
 * @return {string}
 */
export function getFieldParentDetail(fieldId, metaData) {
    prepareMetadataFieldsParents(metaData)
    let fieldMetadata = findFieldMetadata(fieldId, metaData);
    if (!fieldMetadata || !fieldMetadata.parentDetail)
        return;
    return fieldMetadata.parentDetail.fieldId;
}
/**
 *
 * @param {string} actionId
 * @param {namaTypes.NaMaMetaData} metaData
 * @return {namaTypes.GUIActionInfo}
 */
export function findActionsWithActionId(actionId, metaData) {
    makeActionsSearchFast(metaData);
    return metaData.entityActions.actions[metaData.actionsIndexMap.get(actionId)];
}

/**
 *
 * @param {namaTypes.NaMaMetaData} metaData
 */
function makeActionsSearchFast(metaData) {
    if (metaData.actionsIndexMap)
        return;
    metaData.actionsIndexMap = new Map();
    for (let i = 0; i < metaData.entityActions.actions.length; i++) {
        metaData.actionsIndexMap.set(metaData.entityActions.actions[i].id, i);
    }
}

/**
 *
 * @param {namaTypes.NaMaMetaData} metaData
 */
function makeFieldSearchFast(metaData) {
    if (metaData.fieldsIndexMap)
        return;
    metaData.fieldsIndexMap = new Map();
    for (let i = 0; i < metaData.fieldsMetaData.length; i++) {
        metaData.fieldsIndexMap.set(metaData.fieldsMetaData[i].fieldId, i)
    }
}

/**
 *
 * @param {ExtendedNamaMetadata} metadata
 */
export function prepareMetadataFieldsParents(metadata) {
    if (!metadata || metadata.detailFields)
        return;
    let detailFields = metadata.detailFields = new Map();
    metadata.fieldsMetaData.filter((f) => f.detail).forEach((f) => detailFields.set(f.fieldId, f));
    metadata.fieldsMetaData.filter((f) => !f.detail && f.fieldId).forEach((f) => {
        let isDetailSubField = false;
        for (let key of detailFields.keys()) {
            if (f.fieldId.startsWith(key + ".")) {
                let detailField = detailFields.get(key);
                let subFields = detailField.subFields || [];
                subFields.push(f);
                detailField.subFields = subFields;
                f.parentDetail = detailField;
                isDetailSubField = true;
                break;
            }
        }
        if(isDetailSubField)
            f.headerField = false;
        else
            f.headerField = true;
    });

}


/**
 *
 * @param {namaTypes.FetchPreferencesRequest} request
 */
export async function fetchPreferences(request, callback) {
    constructNama();
    /**
     *
     * @type {namaTypes.UIPreferences}
     */
    let preferences = nama.cache.preferences.get(request.owner.ownerId);
    if (!preferences) {
        preferences = {};
        nama.cache.preferences.set(request.owner.ownerId, preferences);
    }

    let diffProperties = getUnfetchedProperties(preferences, request);
    if (diffProperties.length) {
        request.properties = diffProperties;
        let newPreferences = await ajaxJSON(urls.FETCH_PREFERENCES, {request: JSON.stringify(request)});
        for (let property of diffProperties)
            preferences[property] = newPreferences[property];
        if (isMobileDevice()) {
            if (preferences[PreferencesRequest.LIST_LAYOUT] && preferences[PreferencesRequest.LIST_LAYOUT].mobileScreen)
                preferences[PreferencesRequest.LIST_LAYOUT] = preferences[PreferencesRequest.LIST_LAYOUT].mobileScreen;
            if (preferences[PreferencesRequest.SEARCHER_LAYOUT] && preferences[PreferencesRequest.SEARCHER_LAYOUT].mobileScreen)
                preferences[PreferencesRequest.SEARCHER_LAYOUT] = preferences[PreferencesRequest.SEARCHER_LAYOUT].mobileScreen;
        }
    }
    return callback(preferences);
}


export function getCachedCriteria(entityType, listViewName) {
    constructNama();
    let cachedPreferences = nama.cache.preferences.get(entityType);
    let cachedListLayoutPreferences = cachedPreferences ? cachedPreferences.listLayoutPreferences : null;
    if (cachedListLayoutPreferences && isTheSameLayout(cachedListLayoutPreferences.layoutId, listViewName))
        return cachedListLayoutPreferences.criteria;
    return null;
}

export function getCachedOrderBy(entityType, listViewName) {
    constructNama();
    let cachedPreferences = nama.cache.preferences.get(entityType);
    let cachedListLayoutPreferences = cachedPreferences ? cachedPreferences.listLayoutPreferences : null;
    if (cachedListLayoutPreferences && isTheSameLayout(cachedListLayoutPreferences.layoutId, listViewName))
        return cachedListLayoutPreferences.sortBy;
    return null;
}

export function getCachedDisplayedColumns(entityType, listViewName) {
    constructNama();
    let cachedPreferences = nama.cache.preferences.get(entityType);
    let cachedListLayoutPreferences = cachedPreferences ? cachedPreferences.listLayoutPreferences : null;
    if (cachedListLayoutPreferences != null && isTheSameLayout(cachedListLayoutPreferences.layoutId, listViewName))
        return cachedListLayoutPreferences.displayedColumns;
    return null;
}

export function getCachedQuestionFields(entityType, listViewName) {
    constructNama();
    let cachedPreferences = nama.cache.preferences.get(entityType);
    let cachedListLayoutPreferences = cachedPreferences ? cachedPreferences.listLayoutPreferences : null;
    if (cachedListLayoutPreferences != null && isTheSameLayout(cachedListLayoutPreferences.layoutId, listViewName))
        return cachedListLayoutPreferences.questionFields;
    return null;
}


/**
 *
 * @param {namaTypes.UIPreferences} current
 * @param {namaTypes.FetchPreferencesRequest} request
 * @returns {*}
 */
function getUnfetchedProperties(current, request) {
    if (!current)
        return request.properties;
    let unFetchedProperties = [];
    for (let property of request.properties)
        if (!isPropertyFetched(current, property, request))
            unFetchedProperties.push(property);
    return unFetchedProperties;
}

/**
 *
 * @param {namaTypes.UIPreferences} current
 * @param property
 * @param {namaTypes.FetchPreferencesRequest} request
 * @returns {*}
 */
function isPropertyFetched(currentPreferences, property, request) {
    if (areEqual(property, PreferencesRequest.EDIT_LAYOUT))
        return isNotEmptyOrNull(currentPreferences.editLayout)
            && isTheSameLayout(currentPreferences.editLayout.id, request.editLayoutScreenName);
    if (areEqual(property, PreferencesRequest.LIST_LAYOUT))
        return isNotEmptyOrNull(currentPreferences.listLayout)
            && isTheSameLayout(currentPreferences.listLayout.id, request.listLayoutScreenName);
    if (areEqual(property, PreferencesRequest.LIST_LAYOUT_PREFERENCES))
        return isNotEmptyOrNull(currentPreferences.listLayoutPreferences)
            && isTheSameLayout(currentPreferences.listLayoutPreferences.layoutId, request.listLayoutScreenName);
    if (areEqual(property, PreferencesRequest.VIEW_NAMES))
        return isNotEmptyOrNull(currentPreferences.viewNames);
    if (areEqual(property, PreferencesRequest.META_DATA))
        return isNotEmptyOrNull(currentPreferences.metaData);
    if (areEqual(property, PreferencesRequest.SEARCHER_LAYOUT))
        return isNotEmptyOrNull(currentPreferences.searcherLayout)
            && isTheSameLayout(currentPreferences.searcherLayout.id, request.searcherLayoutScreenName);
    return false;
}

export function isTheSameLayout(actualId, toCheckId) {
    if (isEmptyOrNull(actualId))
        actualId = StringConstants.DEFAULT;
    if (isEmptyOrNull(toCheckId))
        toCheckId = StringConstants.DEFAULT;
    return areEqual(actualId, toCheckId);
}

function constructNama() {
    if (!window.nama)
        window.nama = {};
    if (!nama.cache)
        nama.cache = {};
    if (!nama.cache.preferences)
        nama.cache.preferences = new Map();
}